import React from 'react'

import styles from 'components/pages/support/help/helpStyles'
import { HelpComponentProps } from 'types/Help'
import { useFormatMessage } from 'lib/localization'
import { isMyFeatureOn } from 'lib/splitio'
import { FEATURES } from 'lib/splitioFeatures'

function EndUserQuarantineNotificationI18n({ classes }: { classes: ReturnType<typeof styles> }) {
  const formatMessage = useFormatMessage('ess.help_end_user_quarantine_notification')
  return (
    <div className={classes.content} data-testid="content">
      <p>{formatMessage('intro')}</p>
      <p>{formatMessage('link_validity')}</p>
      <p />
      <ul>
        <li>
          <b>{formatMessage('settings.quarantine_messages.label')}</b>
          <br />
          {formatMessage('settings.quarantine_messages.description')}
        </li>
        <li>
          <b>{formatMessage('settings.default_interval.label')}</b>
          <br />
          {formatMessage('settings.default_interval.description')}
          <ul>
            <li>
              <b>{formatMessage('settings.default_interval.never.label')}</b>
              <br />
              {formatMessage('settings.default_interval.never.description')}
            </li>
            <li>
              <b>{formatMessage('settings.default_interval.scheduled.label')}</b>
              <br />
              {formatMessage('settings.default_interval.scheduled.description')}
            </li>
          </ul>
        </li>
      </ul>
    </div>
  )
}

function EndUserQuarantineNotification(_props: HelpComponentProps) {
  const classes = styles()
  let isSmartlingEnabled = false
  try {
    isSmartlingEnabled = isMyFeatureOn(FEATURES.EGD_React_Smartling_Translations)
  } catch {
    // Default to OFF when called outside Redux context (e.g., renderToString for search)
  }

  // Flag ON: Use translated content
  if (isSmartlingEnabled) {
    return <EndUserQuarantineNotificationI18n classes={classes} />
  }

  // Flag OFF: Original hardcoded English content
  return (
    <div className={classes.content} data-testid="content">
      <p>
        The Barracuda Email Gateway Defense can send you notifications (a quarantine digest) at predefined intervals,
        indicating that you have quarantined messages. If enabled by your system administrator, you can set the
        notification interval from this page. Notifications only go out if new mail is quarantined since the last
        notice.
      </p>
      <p>
        The links in the quarantine notification email allow you to access your Barracuda Email Gateway Defense user
        account without entering your username and password. The link is valid for seven days, after which you must log
        in manually at https://ess.vt2.barracudanetworks.com.
      </p>
      <p />
      <ul>
        <li>
          <b>Quarantine messages</b>
          <br />
          When set to <b>Yes</b>, messages that would be blocked by intent are instead quarantined.
        </li>
        <li>
          <b>Default interval for user quarantine notifications</b>
          <br />
          Specify whether to <b>Never</b> send user quarantine notifications or create <b>Scheduled</b> user quarantine
          notifications.
          <ul>
            <li>
              <b>Never</b>
              <br />
              Mail is quarantined but no notification is sent.
            </li>
            <li>
              <b>Scheduled</b>
              <br />
              Select the day and time quarantine notifications are to be sent using the{' '}
              <b>Schedule notification intervals</b> section.
            </li>
          </ul>
        </li>
      </ul>
    </div>
  )
}

export default EndUserQuarantineNotification
